<template>
  <div>
    <Banner></Banner>

    <div class="main">
      <div class="noticebg" v-if="noticeData.length>0">
        <div class="noticeItem">
          <img class="noticeIcon" src="../../assets/img/noticeIcon.png" alt="">
          <span class="noticeTitle" @click="gotoList(3)">通知公告</span>
          <div class="litterLine"></div>
          <el-carousel height="50px" :interval="5000" direction="vertical" indicator-position="none">
            <el-carousel-item v-for="item in noticeData" :key="item.id" >
              <span class="noticeName" @click="gotoDetail(item, 3)">{{item.name}}</span>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div v-else class="space"></div>
      <div class="manicontent">
        <div class="material">
          <div class="divtitle">
            <div class="lefttitle">
              <img src="../../assets/img/material-icon.png" alt="">
              <p class="name">教材展示</p>
            </div>
            <div class="morebtn" @click="$router.push('/onLine')">更多 >></div>
          </div>
          <div class="matlist">
            <div class="material-item"  v-for="(item,index) in bookData" :key="index" @click="getdetails(item.id)">
              <img class="iconimage" v-lazy="item.coverUrl ? item.coverUrl :rdefimg " alt="">
              <div class="name">{{item.teachName}}</div>
              <div class="price">
                <!-- <span>¥ {{item.pricing}}</span> -->
                <!-- <img class="icon" src="../../assets/img/cart.png" alt="" @click.stop="joinCart(item)"> -->
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="zhengce">
            <div class="divtitle">
              <div class="lefttitle">
                <img class="imgicon" src="../../assets/img/zhengce-icon.png" alt="">
                <div class="name">政策</div>
              </div>
              <div class="morebtn" @click="gotoList(2)">更多 >></div>
            </div>
            <div class="list">
              <ul>
                <li
                  class="clearfix litop"
                  :key="index"
                  v-for="(item, index) in policyData"
                  @click="gotoDetail(item, 2)"
                >
                  <p class="left contenttext">
                    {{ item.name }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <div class="biaozhun">
            <div class="divtitle">
              <div class="lefttitle">
                <img class="imgicon" src="../../assets/img/biaozhun-icon.png" alt="">
                <div class="name">标准</div>
              </div>
              <div class="morebtn" @click="gotoList(1)">更多 >></div>
            </div>
            <div class="list">
                <ul>
                  <li
                    class="clearfix litop"
                    :key="index"
                    v-for="(item, index) in standData"
                    @click="gotoDetail(item, 1)"
                  >
                    <p class="contenttext">
                      {{ item.name }}
                    </p>
                  </li>
                </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="pressbg">
        <div class="divtitle">
          <div class="lefttitle">
            <img src="../../assets/img/press-icon.png" alt="">
            <div class="name">出版社</div>
          </div>
          <div class="morebtn" @click="morePress">更多 >></div>
        </div>
        <div class="presslist">
          <div class="press-item" v-for="(item,index) in PressData" :key="index">
             <img class="pressimg" v-lazy="item.logo ? item.logo : pdefimg" @click="gotourl(item.skypegmwcnUrl)"/>
             <div class="pressName">{{ item.name }}</div>
              <div class="learnMore" @click="gotourl(item.skypegmwcnUrl)">
                了解更多>>
              </div>
              <div class="pressIntro" v-html="item.content? item.content :'暂无简介信息'"></div>
              <div class="pmatlist">
                <div class="mat-item" v-for="(item,index) in item.pressBooksList" :key="index" @click="getdetails(item.id)">
                  <img v-lazy="item&&item.coverUrl ? item.coverUrl :rdefimg" alt="">
                  <p class="bookname">{{ item&&item.teachName ? item.teachName :'' }}</p>
                  <!-- <p class="bookPrice">￥{{ item&&item.pricing ? item.pricing.toFixed(2) :'' }}</p> -->
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <modelNew @close="close" v-if="showModel" :id="bookId"></modelNew>
  </div>
</template>
<script>
import { Loading } from 'element-ui'
import { getSheetId } from '../../api/wapi'
import Banner from '@/components/home/banner.vue'
import modelNew from '../common/modelNew.vue'
import { mapMutations, mapState, mapGetters } from 'vuex'
import {
  selectPolicyAll,
  standardAll,
  NoticeAll,
  selectMaterialCategory,
  selectPress,
  selectTeachingMaterial,
  bigMajor,
} from '../../api/home/index.js'

import { hasSemester } from '../../api/index.js'
const rdefimg = require('../../assets/img/noimage.jpeg');
const pdefimg = require('../../assets/img/deficon.png');
// import rdefimg from '../../assets/img/no-cover.png';
export default {
  data() {
    return {
      dataArr: ['出版社', '专业'],
      rdefimg:rdefimg,
      pdefimg:pdefimg,
      currentBookData: {},
      currentLi: 0,
      matItem: [],
      sheetId: '',
      active: '',
      pageBean: {
        pageNum: 1,
        pageSize: 12,
        typeId: '',
        teamatName: '',
      },
      total: 0,
      pressTotal:0,
      showMajor: false,
      showBook: true,
      currentMajor: 0,
      onOff: false,
      pageParam: {
        pageNo: 1,
        pageSize: 6,
        afficheType: 1,
      },
      pageParamStan: {
        pageNo: 1,
        pageSize: 6,
        afficheType: 2,
      },
      pageParamNotice: {
        pageNo: 1,
        pageSize: 4,
        afficheType: 4,
        platformId:""
      },
      pageParamPress: {
        pageNo: 1,
        pageSize: 4,
      },
      policyData: [],
      standData: [],
      noticeData: [],
      majorData: [],
      PressData: [],
      bookParam: {
        specialtyGeneraId: '',
        platformId:"",
        publishTimeType:0,
        pageNum:1,
        pageSize:8
      },
      bookData: [],
      showModel: false,
      bookId: '',
    }
  },
  computed: {
    ...mapGetters(['resStatus', 'resBookSelectionAuthority','resSchoolId']),
  },
  created() {
    this.getPolicList(this.pageParam)
    this.getStandardList(this.pageParamStan)
    this.pageParamNotice.platformId = this.resSchoolId ? this.resSchoolId :'';
    this.pageParamPress.platformId = this.resSchoolId ? this.resSchoolId :'';
    this.bookParam.platformId = this.resSchoolId ? this.resSchoolId :'';
    this.getNoticeList(this.pageParamNotice);
    // this.getMajorList()
    this.getPressList()
    this.getBookList(this.bookParam)
  },
  provide() {
    return {
      updateList: this.updateList,
    }
  },
  components: {
    Banner,
    modelNew,
  },
  methods: {
    updateList() {},
    gotourl(url) {
      if (url) {
        window.open(url)
      }else{
        this.$message.info("暂无出版社官网信息");
      }
    },
    gotoDetail(item, type) {
      
      localStorage.setItem('item', JSON.stringify(item))
      this.$router.push({
        path: '/newsDetail',
        query: { type: type, id: item.id },
      })
    },
    // 判断是否有可用的选书清单
    visableSheetInfo(matData) {
      let loadingInstance = Loading.service({ background: 'rgba(0,0,0,0.5)' })
      getSheetId()
        .then((result) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
          if (result.data) {
            var data = result.data[0]
            this.sheetId = data.fid
            matData.sheetId = this.sheetId
            matData.materialId = matData.fid
            this.showModel = true
            this.currentBookData = matData
          } else {
            this.$confirm('暂无可供选书的清单，无法进行选书', '提示', {
              showClose: true,
              showCancelButton: false,
              showConfirmButton: false,
            })
          }
        })
        .catch((err) => {
          this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close()
          })
        })
    },
    // 加入选书
    joinCart(data) {
      let token = localStorage.getItem('Token')
      if (!token) {
        this.$confirm('请先登录再进行操作', '提示', {
          showClose: true,
          showCancelButton: false,
          showConfirmButton: false,
        })
        return
      }
      if (this.resBookSelectionAuthority != 1) {
        this.$message.error('您没有选书权限')
        return
      }
      hasSemester().then((res) => {
        if (res.status == 0) {
          this.bookId = data.id
          this.showModel = true
        } else {
          this.$message.error('还没有开启的学期')
          return
        }
      })
    },
    close() {
      this.showModel = false
    },
    changePage(page){
      this.bookParam.pageNum = page;
      this.getBookList(this.bookParam);
    },
    changePressPage(page){
      this.pageParamPress.pageNum = page;
      this.getPressList(this.pageParamPress);
    },
    getBookList(params) {
      selectTeachingMaterial(params)
        .then((res) => {
          if (res.status == 0) {
            res.data.forEach(item => {
              item.pricing = item.pricing.toFixed(2);
            });
            this.bookData = res.data;
            this.total = res.page.total;
          }
        })
        .catch(() => {})
    },
    getPressList() {
      selectPress(this.pageParamPress)
        .then((res) => {
          if (res.status == 0) {
            if (res.data.length>4) {
              this.PressData = res.data.slice(0,4)
            }else{
              this.PressData = res.data
            }
            this.pressTotal = res.page.total;
          }
        })
        .catch(() => {})
    },
    getMajorList() {
      bigMajor()
        .then((res) => {
          if (res.status == 0) {
            this.majorData = res.data
            this.majorData.unshift({
              name: '全部',
              id: '',
            })
          }
        })
        .catch(() => {})
    },
    morePress() {
      localStorage.setItem('index', 2)
      this.$router.push({
        path: '/press',
      })
    },
    gotoList(type) {
      this.$router.push({
        path: '/newslist',
        query: {
          id: type,
        },
      })
    },
    getNoticeList(param) {
      NoticeAll(param)
        .then((res) => {
          if (res.status == 0) {
            this.noticeData = res.data
          }
        })
        .catch(() => {})
    },
    getStandardList(param) {
      standardAll(param)
        .then((res) => {
          if (res.status == 0) {
            this.standData = res.data
          }
        })
        .catch(() => {})
    },
    getPolicList(param) {
      selectPolicyAll(param)
        .then((res) => {
          console.log(res)
          if (res.status == 0) {
            this.policyData = res.data
          }
        })
        .catch(() => {})
    },
    getdetails(fid) {
      this.$router.push({
        path: '/teachingmat/Matdetails',
        query: {
          fid: fid,
        },
      })
    },
    openOrShut() {
      this.onOff = !this.onOff
    },
    selectMajor(index) {
      this.currentMajor = index
      this.bookParam.pageNum = 1;
      this.bookParam.specialtyGeneraId = this.majorData[index].id
      this.getBookList(this.bookParam)
    },
    selectChange(index) {
      if (index == 0) {
        this.showMajor = false
        this.showBook = true
      } else {
        this.currentMajor ? this.currentMajor : 0
        this.bookParam.specialtyGeneraId = this.majorData[this.currentMajor].id
        this.bookParam.pageNum = 1;
        this.getBookList(this.bookParam)
        this.showMajor = true
        this.showBook = false
      }
      this.currentLi = index
    },
  },
}
</script>

<style lang="scss" scoped>
.noticebg{
  height: 50px;
  background-color: white;
  margin: 30px 0px;
  .noticeIcon{
    width: 24px;
    height: 20px;
    padding: 0px 10px;
  }
  .noticeTitle{
    min-width: 70px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #274C9F;
    cursor: pointer;
  }
}
.space{
  height: 40px;
}
.manicontent{
  height: 610px;
  display: flex;
  .matlist{
    padding: 10px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
  }
}
.litterLine{
    width: 2px;
    height: 30px;
    background-color: #274C9F;
    margin: 0px 20px;
  }
.noticeItem{
    display: flex;
    align-items: center;
    justify-content: flex-start;
    border-left: 4px solid #274C9F;
    border-right: 4px solid #274C9F;
    .el-carousel{
      height: 50px;
      line-height: 50px;
      width: 100%;
    }
    .noticeName{
      width: 100%;
      color: black;
      font-size: 16px;
      cursor: pointer;
    }
    .noticeName:hover{
      color: #0082F0;
    }
}
.material{
  width: 910px;
  height: 100%;
  background-color: white;
}
.material-item{
  width: 210px;
  height: 270px;
  background-color: white;
  text-align: center;
  .iconimage{
    margin-top: 10px;
    width: 135px;
    height: 180px;
    object-fit: cover;
    background-color: white;
  }
  .name{
    text-align: justify;
    margin: 0px 38px;
    margin-top: 13px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .price{
    margin-left: 38px;
    margin-top: 8px;
    color: #F62626;
    text-align: left;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #F62626;
  }
  .icon{
    width: 16px;
    height: 16px;
    padding: 10px;
    margin-right: 28px;
  }
}
.material-item:hover{
  background: #FFFFFF;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  z-index: 9;
}
.right{
  width:280px;
  margin-left: 10px;
  .imgicon{
    width: 16px;
    height: 16px;
  }
  .list{
    height: 250px;
    background-color: white;
  }
  .biaozhun{
    margin-top: 10px;
  }
}
.mar {
  margin-left: 0px !important;
}
.noText {
  text-align: center;
  margin-top: 20px;
}
.arrowimg {
  width: 9px;
  height: 5px;
  margin-top: -4px;
  display: inline-block;
  vertical-align: middle;
}
.pressbg{
  margin-top: 60px;
  .presslist{
    display: flex;
    justify-content:flex-start;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 80px;
  }
}
.press-item{
  width: calc(25% - 15px);
  margin-right: 20px;
  height: 750px;
  border-radius: 4px;
  background-color: white;
  padding:0px 20px;
  padding-top: 30px;
}
.press-item:nth-child(4n){
  margin-right: 0px !important;
}
.press-item:hover{
  background: #FFFFFF;
  box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  z-index: 9;
}
.pmatlist{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  padding-top: 30px;
}
.presspage{
  margin-top: 20px;
}
.mat-item{
  cursor: pointer;
  width: 112px;
  text-align: left;
  padding-bottom: 30px;
  img{
    width: 112px;
    height: 155px;
    object-fit: cover;
  }
}
.bookDetailul{
  min-height: 500px;
}
.onOfftext {
  margin-top: 14px;
  font-size: 12px;
  margin-right: 40px;
  display: inline-block;
  vertical-align: middle;
}
.autoHeightMajor {
  height: 100% !important;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
}
.autoHeight {
  height: auto !important;
}
.autoHeightUL {
  height: auto !important;
  margin-left: 100px;
}
.activeMajor {
  background: #0082F0;
  color: #fff !important;
}
.itemBottom{
  padding: 0px 16px;
}
.ml {
  margin-left: 4px;
  font-size: 13px;
  font-family: Microsoft YaHei;
}
.cartimg {
  width: 20px;
  height: 19px;
  display: inline-block;
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}
.divcard {
  width: 102px;
  height: 31px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  margin-top: 10px;
  line-height: 31px;
  text-align: center;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;
}
.pricecolor {
  color: #B80D03;
  font-size: 13px;
}
.commoncss {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
}
.bookTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-bottom: 6px;
  margin-top: 10px;
  max-width: 200px;
}
.majorRight {
  margin-left: 20px;
}
.bookMajorul{
 max-height: 650px;
 overflow: hidden;
 margin-bottom: 20px;
}
.bookMajorul li {
  width: 386px;
  height: 181px;
  margin-bottom: 50px;
}
.majorImg {
  width: 130px;
  height: 181px;
  background-color: #f3f3f3;
  object-fit: contain;
}
.majorul {
  height: 42px;
  width: 935px;
  overflow: hidden;
}
.majorul li {
  margin: 0 14px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  padding: 6px 10px;
  margin-top: 8px;
  margin-bottom: 8px;
}
.majorText {
  width: 98px;
  height: 40px;
  background: #f3f3f3;
  border: 1px solid #e9e9e9;
  line-height: 40px;
  text-align: center;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #333333;
}
.majordiv {
  width: 1200px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;
}
.bookli {
  width: 112px;
  margin-right: 20px;
  font-size: 0px;
}

.bookli:last-child {
  margin-right: 0;
}
.bookPrice {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #F62626;
}
.bookname {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 100%;
  margin: 17px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.itemImg {
  width: 112px;
  height: 155px;
  // background-color: white;
  object-fit: contain;
}
.pressIntro  {
  font-size: 14px !important;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  height: 70px;
  overflow: hidden;
  padding-top: 30px;
  text-align: justify;
}
.learnMore {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  opacity: 0.8;
}
.learnMore:hover{
  color: #0082F0;
}
.pressName {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0082F0;
  margin-bottom: 10px;
  margin-top: 20px;
}
.pressimg {
  width: 140px;
  height: 40px;
  display: block;
  background-color: white;
  border: 1px solid #e6e6e6;
  padding: 5px;
}
.Detailheader {
  padding-bottom: 20px;
  border-bottom: 1px solid #bdbdbd;
  margin-bottom: 40px;
}
.bookDetailli:nth-of-type(even) {
  margin-right: 0px !important;
}
.bookDetailli {
  padding: 30px 20px;
  width: 580px;
  height: 500px;
  margin-top: 30px;
  background: #FAFAFA;
  
}
.bookDetailli:hover{
  box-shadow: 2px 0px 12px 0px rgba(0, 0, 0, 0.08);
}
.bookDetailli:nth-child(2n+1){
  margin-right: 40px;
}
.pressPublic {
  margin-top: 70px;
  margin-bottom: 40px;
}
.activeli {
  background: #0082F0;
  color: #ffffff !important;
}
.booknavli {
  width: 102px;
  height: 38px;
  line-height: 38px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #343434;
  text-align: center;
}
.bookText {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #343434;
  margin-left: 10px;
  margin-right: 40px;
}
.bookicon {
  display: block;
  margin-top: 8px;
}
.pressHeader {
  height: 38px;
  border-bottom: 1px solid #0082F0;
  line-height: 38px;
  .right {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
  }
}
.borderCommon {
  border-bottom: 1px solid #0082F0;
}
.levelimg {
  width: 100px;
  height: 55px;
  margin-right: 16px;
}
.colorNotice {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #0082F0;

}
.divtitlethree {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #0082F0;
  margin-left: 10px;
}
.contenttext {
  cursor: pointer;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
  text-align: justify;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: justify;
}
.contenttime {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 14px;
}
.contenttextsecond {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-left: 5px;
  width: 415px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.contenttextthree {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-left: 5px;
  width: 238px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-align: justify;
}
.litop {
  padding: 0px 20px;
  padding-top: 13px;
  p:hover{
    color: #0082F0;
  }
}
.notice {
  margin-top: 14px;
}
.clearfix:after {
  content: '.';
  display: block;
  clear: both;
  visibility: hidden;
}
.kailong {
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-left: 6px solid #0082F0;
  margin-top: 2px;
}
.textcolor {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
  margin-right: 10px;
}
.matTitle{
    width: 88px;
  height: 40px;
  background: #0082F0;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
  text-align: center;
}
.divtitle {
  background-color: #274C9F;
  border-radius: 4px 4px 0px 0px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .lefttitle{
    display: flex;
    align-items: center;
  }
  img{
    width: 20px;
    height: 20px;
    padding: 0px 10px 0px 20px;
  }
  .name{
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #FFFFFF;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
  }
  .morebtn{
    cursor: pointer;
    color: white;
    margin-right: 10px;
  }
}
.noticeAll {
  margin-top: 60px;
}
.divItemthree .itemheader {
  height: 40px;
  background: #F1F9FF;
  line-height: 40px;
  width: 256px;
}
.itemheader {
  width: 432px;
  height: 40px;
  background: #F1F9FF;
  line-height: 40px;
}
.divItem {
  width: 432px;
  height: 250px;
  margin-right: 40px;
}
.divItemthree {
  width: 256px;
  height: 250px;
  background: #fcfcfc;
}
.banner {
  width: 100%;
  height: 180px;
  img {
    width: 100%;
    height: 180px;
  }
}
.sort {
  overflow: hidden;
  margin-top: 35px;
  margin-bottom: 25px;
  .major {
    float: left;
    font-size: 14px;
    font-family: SourceHanSansCN;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    margin-right: 20px;
    margin-top: 5px;
  }

  .majorItem {
    float: left;
    width: 956px;
    .item {
      height: 23px;
      font-size: 14px;
      color: rgba(102, 102, 102, 1);
      line-height: 23px;
    }
  }
}
.itemMar {
  margin: 30px 0;
}
.active {
  float: left;
  width: 80px;
  height: 23px;
  background: #0082F0;
  border-radius: 2px;
  font-size: 14px;
  color: rgba(255, 255, 255, 1) !important;
  line-height: 23px;
  text-align: center;
  margin-right: 30px;
}
.item {
  width: 100%;
  height: 100%;
  // overflow: hidden;
  // height: 482px;
  .itemImg {
    width: 100%;
    height: 180px;
  }
  .itemInfo {
    width: 100%;
    height: 180px;
    overflow: hidden;
    .itemTit {
      margin-top: 17px;
      font-size: 16px;
      color: rgba(51, 51, 51, 1);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-bottom: 18px;
    }
    .userInfo {
      text-align: left;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      margin-bottom: 10px;
    }
    .textInfo {
      text-align: left;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      line-height: 20px;
      text-overflow: -o-ellipsis-lastline;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }
  }
}
.searchBut {
  width: 77px;
  height: 34px;
  background: #0082F0;
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  line-height: 34px;
  text-align: center;
  margin-top: 20px;
  cursor: pointer;
}
</style>
<style lang="scss">
.block {
  margin-top: 30px;
  padding-bottom: 30px;
}
.el-pager {
  font-size: 12px !important;
  color: rgba(102, 102, 102, 1);
  li {
    width: 32px;
    height: 27px;
    border: 1px solid rgba(153, 153, 153, 1);
    margin-right: 15px !important;
    font-weight: 400;
  }
}
.el-pager li.active {
  color: #fff !important;
  background: #0082F0;
  cursor: pointer;
}
.el-pager li.active + li {
  border-left: 1px solid #999;
}
</style>
